import transformRequest from './helpers/transform';

/**
 * This transform Layer is used by component like
 * Fare List Container
 */

/**
 * This method return a Request object after delete unnecesary paramter
 * @param {*} request Request Object pass to client request API axios at this moment
 */
const transformRequestGroupRoutes = (
  request,
  customParamsToDelete = [],
  customParamsToDeleteIfEmpty = []
) => {
  // params to delete don't matter the value store
  const paramsDelete = [
    'airlineIataCode',
    'siteEdition',
    'page',
    'airport',
    'outputCurrencies',
    'airlineCode',
    ...customParamsToDelete
  ];

  // params to delete when has empty value
  const paramsEmpty = [
    'origins',
    'destinations',
    'outputCurrencies',
    'markets',
    'currencyPricingSettings',
    'travelClasses',
    ...customParamsToDeleteIfEmpty
  ];

  const cleanRequest = transformRequest(request, paramsDelete, paramsEmpty);

  return cleanRequest;
};

export default transformRequestGroupRoutes;
